const Config = {
  translateLink: true,
  csvHeadRow: ['英文（English）', '日语（日本語）', '繁体中文（中文(繁體)）'],
  localeMapKey: [
    {
      key: 'zh_CN',
      localeKey: '中文（中文(简体)）'
    },
    {
      key: 'en_US',
      localeKey: '英文（English）'
    },

    {
      key: 'ja_JP',
      localeKey: '日语（日本語）'
    }
  ],
  langJsonMapper: {
    en: 'en_US',
    'zh-cn': 'zh_CN',
    'zh-tc': 'zh_HK',

    ja: 'ja_JP',
    'zh-Hant': 'zh_HK',
    'zh-Hans': 'zh_CN'
  },
  LOCALE_DATA: {
    en: () => import(/* webpackChunkName: "locale-en_US",  */ '@src/global-locales/build/en_US.json'),
    'zh-cn': () => import(/* webpackChunkName: "locale-zh_CN",  */ '@src/global-locales/build/zh_CN.json'),
    'zh-tc': () => import(/* webpackChunkName: "locale-zh_HK",  */ '@src/global-locales/build/zh_HK.json'),
    ja: () => import(/* webpackChunkName: "locale-ja_JP",  */ '@src/global-locales/build/ja_JP.json'),
    'zh-Hant': () => import(/* webpackChunkName: "locale-zh_HK",  */ '@src/global-locales/build/zh_HK.json'),
    'zh-Hans': () => import(/* webpackChunkName: "locale-zh_CN",  */ '@src/global-locales/build/zh_CN.json')
  }
};

export default Config;
